import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Alert from '@material-ui/lab/Alert';
import strings from 'strings';
import { When } from 'UI/components/atoms';

import { useStyles } from './AutomaticReminder.styled';

const SENDOVER_ATM_REMINDER_SUPPORT_URL =
  window.GPAC_ENV?.SENDOVER_ATM_REMINDER_SUPPORT_URL ||
  process.env.REACT_APP_SENDOVER_ATM_REMINDER_SUPPORT_URL;

const { hiringAuthorityAutomaticReminder: COPIES } = strings.sendoutsV2.form.sections.emailDetails;

const AUTOMATIC_REMINDER_FIELD = 'automaticReminder';

export const AutomaticReminder = ({
  shouldDisplayAutomaticReminderCopy = false,
  shouldDisplayAutomaticReminderCheckbox = false
}) => {
  const { control } = useFormContext();
  const classes = useStyles();

  const automaticReminderDescription = shouldDisplayAutomaticReminderCheckbox
    ? COPIES.topPerformerDescription
    : COPIES.description;

  return (
    <>
      <When condition={shouldDisplayAutomaticReminderCopy}>
        <Alert
          className={classes.atmReminderContainer}
          action={
            <When condition={!!SENDOVER_ATM_REMINDER_SUPPORT_URL}>
              <Button
                color="inherit"
                size="small"
                className={classes.atmReminderAlertButton}
                href={SENDOVER_ATM_REMINDER_SUPPORT_URL}
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
              >
                {COPIES.learnMore}
              </Button>
            </When>
          }
          severity="info"
        >
          {automaticReminderDescription}
        </Alert>
      </When>
      <When condition={shouldDisplayAutomaticReminderCheckbox}>
        <div className={classes.atmReminderContainer}>
          <Controller
            name={AUTOMATIC_REMINDER_FIELD}
            control={control}
            defaultValue={false}
            as={
              <FormControlLabel
                data-testid="automatic-reminder-checkbox"
                label={COPIES.label}
                labelPlacement="end"
                control={<Checkbox color="primary" />}
              />
            }
            onChangeName="onChange"
            valueName="checked"
          />
        </div>
      </When>
    </>
  );
};
